let persistentStore = {
  get length() {
    return this.keys.length;
  },

  keys: [],
  values: [],

  getItem(key) {
    var index = this.keys.indexOf( key );

    // Local storage returns null if it doesn't exist
    return ( index === -1 ) ? null : this.values[ index ];
  },

  setItem(key, value) {
    var index = this.keys.indexOf( key );

    //Didn't exist, set in keys to get the new index (this returns length)
    if ( index === -1 ) index = this.keys.push( key ) -  1;

    //Add to values
    this.values[ index ] = value;
  },

  removeItem(key) {
    //Get the index
    var index = this.keys.indexOf( key );

    //Exists, remove it and the value
    if ( index !== -1 )
    {
        //Take out of keys
        this.keys.splice( index, 1 );

        //Remove from values
        this.values.splice( index, 1 );
    }
  },

  clear() {
    // Re-init both
    this.keys = [];
    this.values = [];
  }

};

export default persistentStore;



// WEBPACK FOOTER //
// ./public/pages/persistentStore.js